import React from 'react';
import {withStyles} from '@material-ui/core';
import {Show} from 'react-admin';
import {styles} from './styles';

export default withStyles(styles)(({classes, ...rest}) => (
  <Show className={classes.root} {...rest} />
));
